import { ResourceType, RunWorkflowNodeDataSchema } from '@cotera/api';
import type { WorkflowNodeData } from '../types';
import type {
  WorkflowNodeHydration,
  WorkflowNodeResourceRef,
  WorkflowNodeUpstreamRef,
} from '../workflow-node-base';
import { nonBlank } from './output-shape-helpers';
import { TypedWorkflowNode } from './typed-workflow-node';

/**
 * Triggers another persisted workflow by id and waits for its run to finish.
 * Used in ephemeral wrapper graphs (e.g. Coco workflow tools).
 */
export class RunWorkflowWorkflowNode extends TypedWorkflowNode<
  typeof RunWorkflowNodeDataSchema
> {
  protected readonly schema = RunWorkflowNodeDataSchema;

  static override create(
    data: WorkflowNodeData,
    hydration: WorkflowNodeHydration
  ): RunWorkflowWorkflowNode {
    return new RunWorkflowWorkflowNode(data, hydration);
  }

  override resourceRefs(): readonly WorkflowNodeResourceRef[] {
    const targetWorkflowId = nonBlank(this.config?.targetWorkflowId);
    return targetWorkflowId === undefined
      ? []
      : [
          {
            type: ResourceType.Workflow,
            id: targetWorkflowId,
            field: 'targetWorkflowId',
          },
        ];
  }

  override upstreamRefs(): readonly WorkflowNodeUpstreamRef[] {
    return this.bindingMapRefs(this.config?.inputBindings);
  }
}
